package com.nnod.landing.web

private val PATH_SAFE_CHARACTERS =
    ('A'..'Z') + ('a'..'z') + ('0'..'9') + listOf('-', '.', '_', '~', ':', '@', '!', '$', '&', '\'', '(', ')', '*', '+', ',', ';', '=')

internal fun String.encodeRouteSegment(): String {
    val bytes = encodeToByteArray()
    val encoded = StringBuilder(bytes.size)
    for (byte in bytes) {
        val unsigned = byte.toInt() and 0xFF
        val char = unsigned.toChar()
        if (char in PATH_SAFE_CHARACTERS) {
            encoded.append(char)
        } else {
            encoded.append('%')
            encoded.append(HEX_DIGITS[unsigned ushr 4])
            encoded.append(HEX_DIGITS[unsigned and 0x0F])
        }
    }
    return encoded.toString()
}

internal fun decodeRouteSegmentOrNull(value: String): String? {
    val bytes = ArrayList<Byte>(value.length)
    var index = 0
    while (index < value.length) {
        val char = value[index]
        when {
            char == '%' -> {
                if (index + 2 >= value.length) return null
                val high = hexValue(value[index + 1]) ?: return null
                val low = hexValue(value[index + 2]) ?: return null
                bytes.add(((high shl 4) or low).toByte())
                index += 3
            }
            else -> {
                bytes.addAll(char.toString().encodeToByteArray().asList())
                index += 1
            }
        }
    }
    return bytes.toByteArray().decodeToString()
}

private val HEX_DIGITS = "0123456789ABCDEF".toCharArray()

private fun hexValue(char: Char): Int? = when (char) {
    in '0'..'9' -> char.code - '0'.code
    in 'a'..'f' -> char.code - 'a'.code + 10
    in 'A'..'F' -> char.code - 'A'.code + 10
    else -> null
}
